export default __webpack_public_path__ + "ee9c99c043863adf756bc9e9035c4d20.svg";